<template>
  <div class="report-view">
    <div ref="luckysheet" id="luckysheet"></div>
        <!-- 页眉页脚等元素 -->
    <div class="other-element">
      <!-- 翻书音效 -->
      <audio ref="audio" v-show="false">
        <source :src="trunBookSrc" type="audio/mp3" />
      </audio>
      <!-- 通过状态 -->
      <img id="result1" style="position: absolute; bottom: 50px;right: 50px;" src="@/assets/form-result1.png" />
      <img id="result2" style="position: absolute; bottom: 50px;right: 50px;" src="@/assets/form-result2.png" />
      <img id="result3" style="position: absolute; bottom: 50px;right: 50px;" src="@/assets/form-result3.png" />
      <!-- 页眉页脚 -->
      <div v-for="(item, index) in sheetLength" class="page-header" ref="pageHeaderRef" :key="index+'head'" :style="{height: pageConfig.pageTop + 'mm'}">
        <draggableSet :pageCofig="detailConfig.pageHeaderSet ? detailConfig.pageHeaderSet.pageHeader : {}" :pageCount="sheetLength" :pageNum="item" :isConfig="false" />
      </div>
      <div v-for="(item, index) in sheetLength" class="page-footer" ref="pageFooterRef" :key="index+'foot'" :style="{height: pageConfig.pageTop + 'mm'}">
        <draggableSet :pageCofig="detailConfig.pageHeaderSet ? detailConfig.pageHeaderSet.pageFooter : {}" :pageCount="sheetLength" :pageNum="item" :isConfig="false" />
      </div>
      <!-- 流程元素 -->
      <table class="flow-table" ref="flowTable" style="border-collapse: collapse;" v-if="flowList.length > 0">
        <tbody>
          <tr>
            <td style="border-top: 1px solid #000; border-left: 1px solid #000; display: flex; width: 100%;">
              <div style="padding: 5px;border-right: 1px solid #000;border-bottom: 1px solid #000; display: flex; align-items: center">处理流程</div>
              <div style="display: flex; flex: 1; flex-wrap: wrap;">
                <div v-for="(item, key) in flowList" :key="key" style="width: 100%; display: flex;">
                  <div
                    style="padding: 5px;width: 184px;border-right: 1px solid #000;border-bottom: 1px solid #000; display: flex;align-items: center;"
                  >{{ item.stateUser }}</div>
                  <div
                    style="padding: 5px;border-right: 1px solid #000;border-bottom: 1px solid #000; flex: 1;"
                  >{{ item.stateName }}<span v-if="item.userText" style="font-size: 12px;margin-left: 4px;"
                  >{{ item.userText }}</span><p v-if="item.stateMain" style="font-size: 14px;"
                  >{{ item.stateMain }}</p></div>
                  <div
                    style="padding: 5px;width: 184px;border-right: 1px solid #000;border-bottom: 1px solid #000; display: flex;align-items: center;"
                  >{{item.stateTime}}</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td width="100%" style="text-align: right;">处理结果：{{ flowStatus }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 头部 -->
    <div class="report-view-title" :style="{
        background: previewType ? ' #F5F5F5':'#272727',
        color: previewType ? '#333':'#FFFFFF',
      }">
      <span>{{ reportName }}</span>
      <div class="title-mode" v-if="previewMode.length > 1">
        <el-button-group>
          <el-button :type="previewType === 0 ? 'primary' : '' " @click="changePreviewType(0)">阅读模式</el-button>
          <el-button :type="previewType === 1 ? 'primary' : '' " @click="changePreviewType(1)">滚动模式</el-button>
        </el-button-group>
      </div>
      <!-- 操作按钮 -->
      <span class="r-btn">
        <!-- <el-button @click="testFun">设置行高</el-button> -->
        <template v-if="!isLoadingPage">
          <el-button v-if="isShowBtn('print')" type="primary" v-print="printObj">打印</el-button>
          <el-button v-if="isShowBtn('batchPrint')" type="primary" @click="batchPrint">批量打印</el-button>
          <el-button v-if="isShowBtn('toPdf')" @click="toPdf(reportName)">导出PDF</el-button>
          <el-button v-if="isShowBtn('toImg')" @click="toPNG(reportName)">导出图片</el-button>
          <el-button v-if="isShowBtn('toWord')" @click="toWord(reportName)">导出文档</el-button>
          <button type="primary" ref="batchPrintBtn" v-print="batchPrintObj" style="display: none;"></button>
        </template>
        <el-button v-if="isApproval" @click="$emit('close')">关闭</el-button>
      </span>
    </div>
    <!-- 预览部分 -->
    <div class="report-view-main" :style="{
        background: previewType ? '#E7E7E7' : '#212121',
      }">
      <!-- 翻页的按钮 -->
      <template v-if="previewType === 0">
        <span v-if="showPageNum > 1" class="prve-btn" @click="prvePage">
          <i class="iconfont icon-fanhui1"></i>
        </span>
        <span  v-if="showPageNum < sheetLength" class="next-btn" @click="nextPage">
          <i class="iconfont icon-qianjin"></i>
        </span>
      </template>
      <!-- 翻页预览 -->
      <FlipBook
        v-if="!isLoading && previewType === 0"
        :class="['flipbook', `zoom-${zoomNum * 100}`]"
        ref="flipbook"
        :clickToZoom="false"
        :dragToFlip="false"
        :pages="[null, ...pageList]"
        :startPage="startPage"
        :zooms="[1, 1.25, 1.5, 1.75, 2, 2.25, 2.5]"
        @flip-left-start="$refs.audio.play()"
        @flip-right-start="$refs.audio.play()"
        @flip-left-end="page => bookCurrentPage = page"
        @flip-right-end="flipRightEnd"
        @zoom-end="zooms => zoomNum = zooms" />
      <!-- 滚动预览 -->
      <div id="preview-box" ref="previewBox" :style="[
					!isDownReport && previewType === 0 ? {position: 'absolute', top: '200%'} : {},
					{ transform: `scale(${previewType === 0 ? 1 : zoomNum})`, transformOrigin: 'top center', transition: 'all .5s ease' }
				]"></div>
      <div id="batch-print-box"></div>
    </div>
    <!-- 底部预览操作 -->
    <div v-if="!isMobile" :style="{
				backgroundColor: previewType ? 'rgb(231, 231, 231)' : '#000000'
			}" class="report-view-bottom">
      <!-- 缩放等操作 -->
      <div class="bottom-handle">
        <span class="bottom-handle-l">
          {{ showPageNum > sheetLength ? sheetLength : showPageNum  }} / {{ sheetLength }}页
        </span>
        <span class="bottom-handle-c">
          <span class="bottom-handle-reduce">
            <i class="WSiconfont WSicon-Pl" @click="zoom(0)"></i>
          </span>
          <span>{{ zoomNum * 10 * 10 }}%</span>
          <span class="bottom-handle-amplify">
            <i class="WSiconfont WSicon-Plus1" @click="zoom(1)"></i>
          </span>
        </span>
        <span class="bottom-handle-r" @click="resetZoom()">1:1</span>
      </div>
      <!-- 多数据的操作 -->
      <el-pagination v-if="!isApproval && !isSinglePage && pageTotal > 0" @current-change="handleCurrentChange" v-model:current-page="currentPage" background :page-size="1" layout="total, prev, pager, next, jumper" :total="pageTotal">
      </el-pagination>
    </div>
    <!-- 加载的loading -->
    <div class="mask-box" v-show="isLoading">
      <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/download.gif" alt="">
      <span class="mask-box-text">数据加载中请稍后</span>
        <!-- <i class="iconfont icon-tianjia1" @click="isLoading = false"></i> -->
      <!-- <el-button @click="dialogVisible = false">关闭</el-button> -->
    </div>
  </div>
</template>

<script>
import { getCustomVal } from '@/util/customData.js'
import DealPrintData from '@/components/common/detailEdit/utils/dealPrintData.utils.js'
import { getreportmanagementbyid } from '@/port/reportView/reportApi.js'
import { isJSON, urlToBinary } from '@/api/utils.js'
import { formatDate, getOrgShowName } from "@/api/global.js";
import options from './js/excelOptions'
import warterMark from "./js/waterMark" // 水印设置
import jsPDF from '../../../public/static/print/jspdf.min.js'

import htmlDocx from 'html-docx-js/dist/html-docx'
import axios from 'axios'
import dayjs from 'dayjs'
import html2canvas from 'html2canvas'
import { cloneDeep, throttle } from 'lodash'
import QRCode from 'qrcode'
import saveAs from 'file-saver'
import FlipBook from '@gladesinger/flipbook-vue3'
import "@gladesinger/flipbook-vue3/dist/style.css"
import parmsMixins from '@/components/schoolInstrument/mixins/parmsMixins'
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
const luckysheet = window.luckysheet // 表格实例
export default {
  name: 'reportView',
  data () {
    return {
      detailConfig: {},
      reportId: 0, // 报表id
      search: {}, // 筛选条件
      printObj: {
        id: 'preview-box',//id
        popTitle: "标题", //自定义设置标题
      }, //打印的配置
      batchPrintObj: {
        id: 'batch-print-box',//id
        popTitle: "标题", //自定义设置标题
      }, //批量打印的配置
      isShowReport: false,
      isView: false,
      isLoading: true,
      options: { devicePixelRatio: 1, ...options },
      pageList: [],
      sheetLength: 0,
      bookCurrentPage: 1, // 预览模式现在显示的页码
      startPage: 0, // 阅读模式启示的页面
      reportFormId: 0, // 根据reportFormId获取数据
      zoomNum: 1, // 放大的倍数
      previewType: 0, // 预览的方式 0 是翻页 1 是滚动
      formdata: {}, // 数据
      isLoadingPage: false, // 页面加载loading
      isCustom: false, // 是否是定制的页面
      currentPage: 1, // 分页
      pageTotal: 0,
      trunBookSrc: 'https://bigdata.topeti.com/PCRepository/mp3/turnBook.mp3', // 翻书音效
      isSpace: false,
      isUpace: false,
      spaceId: null,
      upaceId: null,
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
      flowList: [], // 流程列表
      flowStatus: '', // 流程结果
      launchdata: "发起",
      launchdataPl: "评论",
      launchdataChH: "撤回",
      appInfo: {
        lookqrcode: 0,
        lookqrcodetypes: [],
        oqrcore: 0,
        qrcodetypes: []
      }, // 本表的二维码配置
      codeObj: {}, // 二维码的地址
      reportPage: [], // 压缩包下载的页面
      isDowning: false,
      customData: [], // 变量
      masterDataList: [], // 主数据源所有的数据
      otherOriginalData: {},
      isInitPages: false,
      initPageNum: 3,
      actions: null,
      defaultSheetList: []
    }
  },
  mixins: [parmsMixins],
  props: {
    id: {}, // 报表的id没传的话config必传
    config: {
      type: Object,
      default: () => { return {} }
    },
    tableData: {
      type: Object,
      default: () => { return {} }
    },
    // 是否是应用内的报表
    isApproval: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isAllFiles: {
      type: Boolean,
      default: false
    },
    auditList: { // 流程数据
      type: Array,
      default: () => []
    },
    auditbuttonList: { // 流程按钮
      type: Array,
      default: () => []
    },
    fieldQuery: { // 传参信息
      type: Object,
      default: () => {}
    },
    isDownReport: { // 是否是批量下载报表
      type: Boolean,
      default: false
    },
    fileInfo: { // 批量下载报表的内容设置
      type: Object,
      default: () => {}
    },
    customDeskInfo: {
      type: Object,
      default:()=> ({})
    }
  },
  computed: {
    // 报表名字
    reportName () {
      return this.detailConfig.canvasName
    },
    // 当前页数
    showPageNum () {
      return this.bookCurrentPage === 1 ? this.bookCurrentPage : this.bookCurrentPage + 1
    },
    excelIndex () {
      let index = this.detailConfig?.activeExcel
      if (index === 0 || this.detailConfig.sheetConfig[index] === undefined) {
        index = Object.keys(this.detailConfig.sheetConfig)[0]
      }
      return index
    },
    // 当前页的配置信息
    pageConfig () {
      return this.detailConfig.sheetConfig[this.excelIndex]
    },
    // 打印区域宽
    printW () {
      let W
      // 横
      if (this.pageConfig.pageDirection === 'landscape') {
        W = this.pageConfig.excelHeight - this.pageConfig.pageBottom - this.pageConfig.pageTop
      } else {
        // 纵
        W = this.pageConfig.excelWidth - this.pageConfig.pageLeft - this.pageConfig.pageRight
      }
      return W
    },
    // 打印区域高
    printH () {
      let H
      // 横
      if (this.pageConfig.pageDirection === 'landscape') {
        H = this.pageConfig.excelWidth - this.pageConfig.pageLeft - this.pageConfig.pageRight
      } else {
        // 纵
        H = this.pageConfig.excelHeight - this.pageConfig.pageBottom - this.pageConfig.pageTop
      }
      return H
    },
    // 预览模式
    previewMode () {
      if (!Array.isArray(this.detailConfig.previewMode)) {
        // this.previewType = this.detailConfig.previewMode
        return [this.detailConfig.previewMode ? 0 : 1]
      } else {
        // this.previewType = this.detailConfig.previewMode[0]
        return this.detailConfig.previewMode
      }
    },
    // 是否有设置页眉页脚
    isPageSet () {
      let isPageSet = false
      if (this.detailConfig.pageHeaderSet !== undefined) {
        for (let key in this.detailConfig.pageHeaderSet) {
          const pageItem = this.detailConfig.pageHeaderSet[key]
          for (let pageItemkey in pageItem) {
            // 存在配置就是需要设置页眉页脚
            if (pageItem[pageItemkey].length > 0) {
              isPageSet = true
              break
            }
          }
        }
      }
      return isPageSet
    },
    // 是否是单份显示
    isSinglePage () {
      return this.detailConfig.dataSourceShowType === 'singlePage'
    },
    // 主数据源是否汇总
    isSummary () {
      let isSummary = false
      if (Array.isArray(this.detailConfig.dataSource.summary)) {
        this.detailConfig.dataSource.summary.forEach(item => {
          if (item.conditionField) {
            isSummary = true
          }
        })
      }
      return this.isSinglePage && isSummary
    }
  },
  watch: {
    id: {
      handler (val) {
        if (val) {
          this.reportId = val
        }
      },
      immediate: true
    },
    fieldQuery: {
      handler (val) {
        if (JSON.stringify(val) !== '{}') {
          for (let key in val) {
            this.search[key] = Array.isArray(val[key]) ? val[key] : [val[key]]
          }
        }
      },
      immediate: true,
      deep: true
    },
    config: {
      handler (val) {
        // 如果是应用内打开配置从外部传入所以就不用获取了
        if (JSON.stringify(val) !== '{}') {
          this.detailConfig = cloneDeep(val)
          this.defaultSheetList = cloneDeep(val.sheetList)
        }
      },
      immediate: true,
      deep: true
    },
    tableData: {
      handler (val) {
        this.formdata = cloneDeep(val)
      },
      immediate: true,
      deep: true
    },
    auditList: {
      handler (val) {
        if (val.length > 1 && this.detailConfig.isFlow) {
          this.flowList = this.auditPrinting(val, this.auditbuttonList)
        }
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    FlipBook,
    draggableSet: () => import('./cpns/draggableSet'),
  },
  methods: {
    // 批量打印
    async batchPrint () {
      const self = this
      this.$statusMsg.loadingMsg({
        additionalTips: '数据准备中...',
        schedule: 0,
        confirmFun: async (actions) => {
          self.actions = actions
        }
      })
      // 获取所有数据
      await this.getDataSoure(true)
      const ElPrint = document.querySelector('#batch-print-box')
      ElPrint.textContent = ''
      let index = 0
      for (let data of this.masterDataList) {
        if (this.actions) {
          let len = (index / this.masterDataList.length) * 100
          len = len.toString().includes('.') ? len.toFixed(2) : len
          this.actions.upLoading(len)
        }
        // 开始生成表格
        await this.setBatchPrintPage(data, index)
        if (index === this.masterDataList.length - 1) {
          if (this.actions) {
            this.actions.upLoading(100)
            this.actions.fromParent({ isShow:false })
          }
          setTimeout(() => {
            this.$refs.batchPrintBtn.click()
          }, 100)
        }
        index++
      }
    },
    setBatchPrintPage(data) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        // 获取其他表和工坊的数据
        if (this.detailConfig.dataSource.formList && this.detailConfig.dataSource.formList.length > 0) {
          const { otherData, otherOriginalData } = await DealPrintData.getOtherApproval(this.detailConfig, cloneDeep(data), this.spaceId, this.upaceId, cloneDeep(this.customData))
          data = { ...data, ...otherData, otherOriginalData }
        }
        data = await DealPrintData.getRelationUserInfo(data)
        await this.initData(data)
        const excelConfig = cloneDeep(this.detailConfig.sheetList)
        const options = cloneDeep(this.options)
        options.data = excelConfig
        options.hook = {
          workbookCreateAfter: () => { // luckysheet创建之后
            luckysheet.refreshFormula()
            this.getInfo(true)
            resolve(true);
          }
        }
        luckysheet.create(options)
      })
    },
    prvePage () {
      this.$refs.flipbook.flipLeft()
    },
    nextPage: throttle(function() {
      if (!this.isInitPages) {
        this.$refs.flipbook.flipRight()
      } else {
        this.$message.warning('正在加载中...')
      }
    }, 500),
    // 下一页翻页完成
    flipRightEnd (page) {
      this.bookCurrentPage = page
      if (this.pageList.length < this.sheetLength) {
        this.isInitPages = true
        this.getPageImageList(this.pageList.length - 1)
      }
    },
    // 获取报表配置
    async getReportConfig () {
      const { code, data, msg } = await getreportmanagementbyid({ reportManagementId: this.reportId })
      if (code === 0 && data.config) {
        this.detailConfig = JSON.parse(data.config)
        this.defaultSheetList = cloneDeep(this.detailConfig.sheetList)
        if (data.variableconfig) {
          this.customData = await this.setParams({ customData: JSON.parse(data.variableconfig) }, null, true)
        }
        if (this.detailConfig.dataSource && this.detailConfig.dataSource.parameters) {
          this.setDataSourceQuery()
        }
        console.log(this.detailConfig, '配置信息')
      } else {
        this.$message.error(msg)
      }
    },
    // 获取控件相关配置
    getSpace () {
      const spaceId = this.$route.query.spaceid
      const spaceStatus = this.$route.query.space
      const upaceId = this.$route.query.upaceid
      const upaceStatus = this.$route.query.upace
      if (typeof(spaceId) !== 'undefined' || spaceStatus){
        this.isSpace = true
        this.spaceId = typeof(spaceId) !== 'undefined' ? spaceId : localStorage.getItem('spaceid')
      } else if (typeof(upaceId) !== 'undefined' || upaceStatus){
        this.isUpace = true
        this.upaceId = typeof(upaceId) !== 'undefined' ? upaceId : localStorage.getItem('upaceid')
      }
    },
    isShowBtn (type) {
      return this.detailConfig && (!this.detailConfig.tonBtnList || this.detailConfig.tonBtnList.includes(type))
    },
    // 获取数据源的数据
    getDataSoure (isGetAllData = false) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        const dataSource = this.detailConfig.dataSource
        if (dataSource.appid) {
          const isFlow = this.detailConfig.isFlow ? true : false
          const { data, dataList, total, flow, buttonList, appInfo } = dataSource.datatype === 2 ?
            await DealPrintData.getShopData({
              appid: dataSource.appid,
              page: this.currentPage,
              search: this.search,
              isSinglePage: isGetAllData || this.isSinglePage
            }) :
            await DealPrintData.getTableData({
              appid: dataSource.appid,
              page: this.currentPage,
              reportFormId: this.reportFormId,
              query: this.search,
              space: false,
              spaceid: this.spaceId,
              upaceid: this.upaceId,
              isFlow,
              isSinglePage: isGetAllData || this.isSinglePage
            })
          this.masterDataList = dataList
          // 主数据源的汇总
          if (this.isSummary) {
            this.masterDataList = this.insertSummaryRows(dataList, this.detailConfig.dataSource.summary)
          }
          this.pageTotal = total || 0
          this.appInfo = { ...this.appInfo, ...appInfo }
          if (this.spaceid) this.appInfo.spaceid = this.spaceid
          if (this.upaceId) this.appInfo.upaceid = this.upaceId
          // 获取二维码所需的地址
          this.codeObj = await DealPrintData.getAppCode(this.appInfo)
          if (isFlow && flow && flow.length > 0) {
            this.flowList = this.auditPrinting(flow, buttonList)
          }
          resolve(data || {})
        } else {
          reject(true)
        }
      })
    },
    // 设置数据源的过滤条件
    setDataSourceQuery () {
      for (const item of this.detailConfig.dataSource.parameters) {
        const title = item.chooseFrom.title
        const type = item.chooseFrom.type
        let value = ''
        if (item.from.datatype === 'custom') {
          // 变量
          value = getCustomVal({ name: item.from.name }, cloneDeep(this.customData))
          value = typeof value === 'string' ? value.split(',') : value
        }
        const key = `${title}_${type}`
        if (this.search[key]) {
          const val = cloneDeep(this.search[key])
          if (Array.isArray(value)) {
            val.push(...value)
          } else {
            val.push(value)
          }
          this.search[key] = Array.from(new Set(val))
        } else {
          this.search[key] = Array.isArray(value) ? value : [value]
        }
      }
    },
    // 审批数据
    auditPrinting (AuditList, buttonList) {
      const statusText = ['处理中', '已通过', '未通过', '已撤回']
      this.flowStatus = statusText[AuditList[0].status] // 流程结果
      var auditListData = AuditList;
      var processData = [];
      auditListData.forEach(elEm => {
        var stateData = {};
        //获取数据
        var typeIs = elEm["type"];
        var statusIs = elEm["status"];
        var wayIs = elEm["way"];
        var approselIs = elEm["approsel"]; //处理流程环节-名称
        //数据构造。判断
        if (wayIs && wayIs == "4") {
          approselIs = this.approvalProcess4(approselIs, buttonList);
          if (elEm.approuser && elEm.approuser.length > 0)
            stateData.userText = elEm.approuser
              .map(vals => {
                return vals.approname;
              })
              .join(",");
        } else if (wayIs && wayIs == "3") {
          approselIs = this.launchdataPl;
        } else {
          if (typeIs == "0" && statusIs != "3") {
            //发起环节获取申请人
            approselIs = this.launchdata;
          } else if (typeIs == "0" && statusIs == "3") {
            approselIs = this.launchdataChH;
          } else if (statusIs == "1" && typeIs == "1" && wayIs != "3") {
            approselIs = this.approvalProcess2(approselIs, buttonList);
          } else if (
            (statusIs == "0" && typeIs == "1" && wayIs != "3") ||
            statusIs == "4"
          ) {
            approselIs = this.approvalProcess1(approselIs, buttonList);
          } else if (statusIs == "2" && typeIs == "1" && wayIs != "3") {
            approselIs = this.approvalProcess3(approselIs, buttonList);
          }
        }
        stateData.stateUser = elEm.user?elEm.user.realname:''; //申请人
        stateData.stateTime = formatDate(
          new Date(elEm.ctime),
          "yyyy-MM-dd hh:mm"
        ); // 处理时间
        stateData.stateName = approselIs; //处理流程
        if (elEm.comment) {
          stateData.stateMain = elEm.comment;
        } else if (elEm.note) {
          stateData.stateMain = elEm.note;
        } else {
          stateData.stateMain = "";
        }
        processData.push(stateData);
      });
      return processData
    },
    approvalProcess1 (val, item) {
      // 测试说这里值和 4  的反了，现在调换一下
      if (!item) {
        return "转 办";
      } else {
        return item[val] && item[val].length > 3 ? item[val][3] : "审批中";
      }
    },
    approvalProcess2 (val, item) {
      if (!item) return "同 意";
      if (val === -1) {
        return item[item.length - 1][0]
      }else {
        return item[val][0];
      }
    },
    approvalProcess3 (val, item) {
      if (!item) return "拒绝";
      if (val === -1) {
        return item[item.length - 1][1]
      } else {
        return item[val][1];
      }
    },
    approvalProcess4 (val, item) {
      if (!item) return "审批中";
      if (val === -1) {
        return "转办";
      } else {
        return item[val][2];
      }
    },
    // 预览模式的变化
    changePreviewType (val) {
      this.previewType = val
      this.bookCurrentPage = 1
      this.resetZoom(.75)
    },
    // 预览模式的操作
    zoom (val) {
      console.log(this.$refs.flipbook, '111111')
      // 1 放大 0 缩小
      if (val === 1) {
        if (this.previewType === 1) {
          this.zoomNum = this.zoomNum < 2.5 ? this.zoomNum + .25 : this.zoomNum
        } else {
          if (this.zoomNum >= 1) {
            this.$refs.flipbook.zoomIn()
          } else {
            this.zoomNum = this.zoomNum < 2.5 ? this.zoomNum + .25 : this.zoomNum
            this.$refs.flipbook.zoom = this.zoomNum
          }
        }
      } else {
        if (this.previewType === 1) {
          this.zoomNum = this.zoomNum > .5 ? this.zoomNum - .25 : this.zoomNum
        } else {
          if (this.zoomNum > 1) {
            this.$refs.flipbook.zoomOut()
          } else {
            this.zoomNum = this.zoomNum > .5 ? this.zoomNum - .25 : this.zoomNum
            this.$refs.flipbook.zoom = this.zoomNum
          }
        }
      }
    },
    // 缩放复原
    resetZoom (scale) {
      this.zoomNum = scale || 1
      if (this.$refs.flipbook) {
        this.$refs.flipbook.zoom = scale || 1
        this.$refs.flipbook.zoomIndex = 0
      }
    },
    // 页数改变
    async handleCurrentChange (page) {
      this.bookCurrentPage = 1
      this.currentPage = page
      this.isLoading = true
      this.destroySheet()
      this.$nextTick(() => {
        this.excelInitial()
      })
    },
    // 销毁lucksheet和预览页面
    destroySheet () {
      console.log('luckSheet删除了', luckysheet)
      this.bookCurrentPage = 1
      // this.$set(this, '', {})
      this.resetZoom()
      luckysheet.destroy()
    },
    // 开始设置报表
    async setReportView () {
      // 如果是应用内打开数据从外部传入
      if (!this.isApproval) {
        // 批量导出的传参替换
        if (this.isDownReport && this.customDeskInfo && this.customDeskInfo.paramsLists) {
          const paramsLists = cloneDeep(this.customDeskInfo.paramsLists)
          this.paramsList = (typeof paramsLists === 'string' ? JSON.parse(paramsLists) : paramsLists) || []
          this.customData = await this.setParams({ customData: cloneDeep(this.customData) }, null, true)
          // 重新走一遍数据源筛选条件的赋值
          this.search = {}
          if (this.detailConfig.dataSource && this.detailConfig.dataSource.parameters) {
            this.setDataSourceQuery()
          }
        }
        const data = await this.getDataSoure() || {}
        this.formdata = cloneDeep(data)
        // 获取其他表和工坊的数据
        if (this.detailConfig.dataSource) {
          const dataSource = this.detailConfig.dataSource
          if (Array.isArray(dataSource.formList) && dataSource.formList.length > 0) {
            const { otherData, otherOriginalData } = await DealPrintData.getOtherApproval(this.detailConfig, data, this.spaceId, this.upaceId, cloneDeep(this.customData))
            this.formdata = { ...data, ...otherData }
            this.otherOriginalData = otherOriginalData
          }
          // 本地过滤数据
          if (Array.isArray(dataSource.filterDataSorce) && dataSource.filterDataSorce.length > 0) {
            const obj = {
              formdata: this.formdata,
              masterData: this.masterDataList,
              customData: this.customData
            }
            const result = await DealPrintData.getFilterData(dataSource.filterDataSorce, obj)
            this.formdata = { ...this.formdata, ...result }
          }
        }
        this.formdata = await DealPrintData.getRelationUserInfo(this.formdata)
        console.log('获取数据结束', this.formdata)
      } else {
        if (JSON.stringify(this.formdata) === '{}' && JSON.stringify(this.tableData) !== '{}') {
          this.formdata = cloneDeep(this.tableData)
        }
      }
      this.initData().then(() => {
        setTimeout(() => {
          const excelConfig = JSON.parse(JSON.stringify(this.detailConfig.sheetList))
          this.options.data = excelConfig
          this.options.hook = {
            workbookCreateAfter: () => { // luckysheet创建之后
              console.log('报表创建结束了~~~')
              luckysheet.refreshFormula()
              this.getInfo()
            }
          }
          luckysheet.create(this.options)
        }, 100)
      }).catch(err => {
        this.isLoading = false
        this.$message.error('报表加载失败', err)
      })

    },
    // 初始化luckysheet
    excelInitial () {
      if (this.detailConfig && this.detailConfig.sheetList) {
        if (this.detailConfig.sheetList[0].data === undefined) {
          this.setTableParams()
        } else {
          this.setReportView()
        }
      }
    },
    // 兼容一下新版的填值
    setTableParams () {
      const excelConfig = JSON.parse(JSON.stringify(this.detailConfig.sheetList))
        this.options.hook = {
          workbookCreateAfter: () => { // luckysheet创建之后
            this.detailConfig.sheetList = this.getParamsData()
            luckysheet.destroy()
            this.setReportView()
          }
        }
        this.options.data = excelConfig
        // luckysheet.create(this.options)
    },
    getParamsData() {
      const sheetConfig = luckysheet.getAllSheets().map(item=>{
        // delete item.data
        item.paramsdata = []
        item.celldata.forEach((iter, index) => {
          if (iter.v.v && typeof iter.v.v === 'string' && iter.v.v.search('{') !== -1) {
            const obj = { ...{ index } , ...iter}
            item.paramsdata.push(cloneDeep(obj))
          }
        })
        return item
      })
      return sheetConfig
    },
    insertSummaryRows(data, summaryConfig) {
      const result = cloneDeep(data)
      // 条件字段、标题填入字段、汇总字段、汇总数据
      const [subConfig, allConfig] = summaryConfig;
      const { conditionField: subGroupByKey, title: subTotaltitle, summaryField: subSummaryKeyList } = subConfig;
      const { conditionField: allGroupByKey, title: allTotaltitle, summaryField: allSummaryKeyList } = allConfig;
      // 汇总字段
      let subTotalData = null
      let allTotalData = null
      // 汇总的个数
      let subTotalNum = 0
      let allTotalNum = 0

      const processGroup = (summaryType, rowData, rowIndex) => {
        // 前一条数据
        const prevRowData = data[rowIndex - 1]
        if (prevRowData) {
          // 汇总数据初始值
          if (summaryType === 'sub') {
            if (!subTotalData) {
              subTotalData = cloneDeep(prevRowData)
            }
          } else {
            if (!allTotalData) {
              allTotalData = cloneDeep(prevRowData)
            }
          }
          let totalData = summaryType === 'sub' ? subTotalData : allTotalData
          // 是否是最后一条数据
          const isLast = rowIndex === data.length - 1
          const titleTip = summaryType === 'sub' ? '小计' : '合计'
          // 汇总条件字段
          const groupByKey = summaryType === 'sub' ? subGroupByKey : allGroupByKey
          // 当前数据
          const currentData = rowData[groupByKey]
          // 前一条数据
          const prevData = prevRowData[groupByKey]
          // 要汇总的字段
          const summaryKeyList = summaryType === 'sub' ? subSummaryKeyList : allSummaryKeyList
          // 标题插入字段
          const insertTotalTitle = summaryType === 'sub' ? subTotaltitle : allTotaltitle
          if (currentData === prevData) {
            // 字段汇总
            summaryKeyList.forEach(summaryKey => {
              const [key, type] = summaryKey.split('_')
              if (type === 'number') {
                // 数字就直接相加
                const val1 = !isNaN(rowData[key]) ? Number(rowData[key]) : 0
                const val2 = !isNaN(totalData[key]) ? Number(totalData[key]) : 0
                totalData[key] = val1 + val2
              } else {
                // 其他类型根据','统计个数
                const val1 = typeof totalData[key] === 'string' ? totalData[key].split(',').length : totalData[key]
                const val2 = typeof rowData[key] === 'string' ? rowData[key].split(',').length : rowData[key]
                totalData[key] = val1 + val2
              }
            })
            // 统计小计的条数
            if (summaryType === 'sub') subTotalNum++
            // 最后一条了
            if (isLast) {
              if (totalData) {
                totalData[insertTotalTitle] = totalData[groupByKey] + titleTip
              }
              const index = summaryType === 'sub' ? subTotalNum + allTotalNum + rowIndex - 1 : subTotalNum + allTotalNum + rowIndex
              result.splice(index, 0, cloneDeep(totalData))
            }
          } else {
            if (totalData) {
              totalData[insertTotalTitle] = totalData[groupByKey] + titleTip
            }
            const index = summaryType === 'sub' ? subTotalNum + allTotalNum + rowIndex - 1 : subTotalNum + allTotalNum + rowIndex
            result.splice(index, 0, cloneDeep(totalData))
            // 重新赋值汇总数据初始值
            if (summaryType === 'sub') {
              subTotalData = cloneDeep(rowData)
            } else {
              allTotalNum++
              allTotalData = cloneDeep(rowData)
            }
          }
        }
      }

      data.forEach((rowData, rowIndex) => {
        if (subGroupByKey && rowData[subGroupByKey]) {
          processGroup('sub', rowData, rowIndex)
        }
        if (allGroupByKey && rowData[allGroupByKey]) {
          processGroup('all', rowData, rowIndex)
        }
      })
      return result;
    },
    // 初始化数据
    initData (_formdata) {
      return new Promise((resolve, reject) => {
        // 隐藏网格
        console.log('初始化数据了', this.formdata, this.masterDataList)
        this.detailConfig.sheetList = cloneDeep(this.defaultSheetList)
        try {
          this.detailConfig.sheetList.forEach((sheet, i) => {
            sheet.paramsdata.forEach(async (e) => {
              if (e.v && e.v.type && e.v.v && JSON.stringify(e.v.v).search('{') !== -1) {
                // 需要设置的值
                let insertData = _formdata || cloneDeep(this.formdata)
                // 主数据源开启了单份显示
                if (this.isSinglePage && e.v.Ftype !== 'others') {
                  if (e.v.condition) {
                    const condition = JSON.parse(e.v.condition)
                    insertData = DealPrintData.getMatchData(condition, this.masterDataList, this.customData)
                  } else {
                    insertData = DealPrintData.getOtherDataFormat(this.masterDataList)
                  }
                }
                let data = insertData[e.v.title + '_' + e.v.type] || insertData[e.v.title]

                if (data === undefined) {
                  const { strArr, str } = this.getWorkShopKey(e.v.v, e.v)
                  data = strArr.length > 1 && insertData[strArr[0]] ? insertData[strArr[0]][strArr[1]] || insertData[strArr[0]] : insertData[str]
                }

                // 把值的颜色设置回去
                if (['#67C23A', '#4e86ff', '#4ea6ff'].includes(e.v.fc)) {
                  this.setCellFormatValue({ celldata: e, sheetIndex: i, format: { fc: '#000' }})
                }
                //明细
                if (e.v.Ftype && e.v.Ftype === 'details') {
                  if (!e.v.appid) {
                    // 兼容一下旧数据 旧的设置没有appid
                    e.v.appid = this.getOtherAppid(e)
                  }
                  this.handleDetail(e, i, insertData)
                } else if (this.isSinglePage && e.v.Ftype !== 'others') {
                  // 单份显示主表数据源的处理
                  const pageNum = Number(e.v.v.split('}')[1] || '1')
                  this.tableSetData(e, i, data, pageNum)
                } else if (e.v.Ftype === 'others') {
                  this.handleOthersTable(e, i, insertData)
                } else if (e.v.type === 'image') { //图片
                  this.handleImage(data, e, i)
                } else if (e.v.type === 'richText') { // 表格的富文本处理 不是平台的富文本控件
                  this.handleRichText(e.v.v, e.r, e.c, i, insertData)
                } else if (data && e.v.type === 'relation-user') { //联系人
                  this.handleUser(e, data || [], i)
                } else if (e.v.type === 'checkbox') { //多选，值是数组要转成字符串
                  let value = data
                  value = Array.isArray(value) ? value.join() : ''
                  this.setCellFormatValue({ celldata: e, sheetIndex: i, format: { v: value }})
                } else if (e.v.type === 'richTextWid') { // 富文本的处理
                  if (data === undefined) {
                    this.setCellFormatValue({ celldata: e, sheetIndex: i, format: { v: '' }})
                    return false
                  }
                  let str = data.split('<p')
                  str = str.map((strItem) => {
                    if (strItem.search('style="') !== -1) {
                      strItem = strItem.replace('style="', 'style="margin: 15px 0;')
                    } else if (strItem && strItem[0] === '>') {
                      strItem = ` style="margin: 15px 0;"${strItem}`
                    }
                    return strItem
                  })
                  this.setCellFormatValue({ celldata: e, sheetIndex: i, format: { v: str.join('<p') }})
                } else if (e.v.type === 'lookcode' || e.v.type === 'datacode') {
                  await this.handleCode(e, i)
                } else {
                  if (e.v.type === 'organization') {
                    data = Array.isArray(data) ? data.map(item => { return getOrgShowName(item) }).join() : data
                  } else if (e.v.type === 'roule') {
                    data = Array.isArray(data) ? data.map(item => { return item.name }).join() : data
                  }

                  this.setCellFormatValue({ celldata: e, sheetIndex: i, format: { v: data }})
                }
              }
            })
          })
        } catch (error) {
          console.log(error)
          reject()
        }
        resolve()
        console.log('赋值结束了~~~~')
      })

    },
    // 单元格的数据过滤
    getMatchData (condition, dataList) {
      const resDataList = []
      for (const data of dataList) {
        const res = isConditionAppen(condition, data, true, this.customData)
        if (res) {
          resDataList.push(data)
        }
      }
      return resDataList
    },
    // 修改表格配置中的format
    setCellFormatValue ({ celldata, sheetIndex, format = {} }) {
      if (this.detailConfig.sheetList[sheetIndex].data[celldata.r] !== undefined) {
        if (this.detailConfig.sheetList[sheetIndex].data[celldata.r][celldata.c] === null) {
          this.detailConfig.sheetList[sheetIndex].data[celldata.r][celldata.c] = { }
        }
        for(const key in format) {
          const val = format[key]
          this.detailConfig.sheetList[sheetIndex].data[celldata.r][celldata.c][key] = val
        }
      }
    },
    // 二维码的处理
    handleCode (e, i) {
      const { type, title} = e.v
      const qrcodeText = this.codeObj[`${type}_${title}`]
      QRCode.toDataURL(qrcodeText ,(err, qrcodeImg) => {
        const { width, height} = this.getTdWH(e.c, e.r)
        const image = new Image()
        image.src = qrcodeImg
        image.width = width
        image.style.height = height + 'px'
        this.setCellFormatValue({ celldata: e, sheetIndex: i, format: { v: this.domToString(image) } })
      })
    },
    // 明细的处理
    handleDetail (e, i, insertData) {
      const pageNum = Number(e.v.v.split('}')[1])
      const appid = this.getOtherAppid(e)
      let detailsData = (insertData[e.v.Ftitle + '_' + e.v.Ftype] || insertData[e.v.Ftitle])
      || (insertData[appid] ? insertData[appid][e.v.Ftitle + '_' + e.v.Ftype] || insertData[appid][e.v.Ftitle] : [])
      if (detailsData && detailsData.length > 0) {
        for (let index = 0; index < pageNum; index++) {
          // 因为下面值改变了 所以重新赋值
          detailsData = (insertData[e.v.Ftitle + '_' + e.v.Ftype] || insertData[e.v.Ftitle])
          || (insertData[appid] ? insertData[appid][e.v.Ftitle + '_' + e.v.Ftype] || insertData[appid][e.v.Ftitle] : [])
          if (Array.isArray(detailsData[0])) {
            detailsData = Array.isArray(detailsData[0][index]) ? {} : detailsData[0][index]
          } else {
            detailsData = Array.isArray(detailsData[index]) ? {} : detailsData[index]
          }

          // 空值就退出
          if (JSON.stringify(detailsData) === '{}' || JSON.stringify(detailsData) === undefined) {
            break;
          }
          this.detailSetValue(e, i, detailsData, index)
          // 标记一下是明细的第几条数据 拓展组块用得到
          const celldata = cloneDeep(e)
          celldata.r = e.r + index
          const format = {
            detailIndex: index,
            Ftitle: e.v.Ftitle,
            Ftype: e.v.Ftype,
            type: e.v.type,
            title: e.v.title
          }
          this.setCellFormatValue({ celldata, sheetIndex: i, format })
        }
      } else {
        // 没有值了就设置为空
        this.setCellFormatValue({ celldata: e, sheetIndex: i, format: { v: '' } })
      }

    },
    // 明细赋值
    detailSetValue (e, sheetIndex, detailsData, index,) {
      const row = e.r + index  // 插入到第几行
      const celldata = cloneDeep(e)
      celldata.r = row
      if (e.v.type === 'checkbox') {
        let value = detailsData[e.v.title + '_' + e.v.type]
        value = Array.isArray(value) ? value.join() : ''
        this.setCellFormatValue({ celldata, sheetIndex, format: { v: value }})
        //明细联系人，值是数组要转成字符串
      } else if (e.v.type === 'relation-user') {
        this.handleUser(celldata, detailsData[e.v.title + '_' + e.v.type] || [], sheetIndex)
      } else if (e.v.type === 'image') {
        this.handleImage(detailsData[e.v.title + '_' + e.v.type], celldata, sheetIndex)
      } else {
        let data = detailsData[e.v.title + '_' + e.v.type]
        if (e.v.type === 'organization') {
          data = Array.isArray(data) ? data.map(item => { return getOrgShowName(item) }).join() : data
        } else if (e.v.type === 'roule') {
          data = Array.isArray(data) ? data.map(item => { return item.name }).join() : data
        }
        this.setCellFormatValue({ celldata, sheetIndex, format: { v: data }})
      }
    },
    // 其他表的处理(明细除外的字段处理)
    handleOthersTable (e, i, data) {
      const pageNum = Number(e.v.v.split('}')[1])
      if (!e.v.appid) {
        // 兼容一下旧数据 旧的设置没有appid
        e.v.appid = this.getOtherAppid(e)
      }
      let dataList = []
      let otherFormdata = data[e.v.appid]

      if (otherFormdata) {
        // 单元格的数据过滤
        if (e.v.condition) {
          const otherOriginalData = data.otherOriginalData || this.otherOriginalData
          const dataArr = cloneDeep(otherOriginalData[e.v.appid])
          const condition = JSON.parse(e.v.condition)
          // 获取匹配的数据列
          const insertData = DealPrintData.getMatchData(condition, dataArr, this.customData)
          if (Array.isArray(insertData)) {
            // 转换成可处理的格式
            otherFormdata = DealPrintData.getOtherDataFormat(insertData)
          }
        }
        if (otherFormdata[`${e.v.title}_${e.v.type}`]) {
          dataList = otherFormdata[`${e.v.title}_${e.v.type}`]
        } else if (otherFormdata[`${e.v.title}`]) {
          // 工坊转换的数据没有type
          dataList = otherFormdata[`${e.v.title}`]
        } else {
          // 工坊明细的用文本去匹配(明细有很多情况 1.其他一级控件一样一种 2.普通明细一样的一种)
          const { strArr, str } = this.getWorkShopKey(e.v.v, e.v)
          dataList = otherFormdata[str] || []
          // 因为工坊都是用文本去匹配的 但是联系人可以选择真实姓名 所以会被识别成明细一样的结构
          if (e.v.type === 'relation-user' && dataList.length <= 0 && strArr.length > 0) {
            dataList = otherFormdata[strArr[0]] || []
          }
          // 要是第一种没有值就试试普通明细这种
          if (dataList.length <= 0 && otherFormdata) {
            if (otherFormdata[strArr[0]]) {
              otherFormdata[strArr[0]].forEach(item => {
                let val = item[strArr[1]] !== undefined ? item[strArr[1]] : ''
                if (strArr.length === 3 && val[strArr[2]] !== undefined) {
                  val = val[strArr[2]]
                }
                dataList.push(val)
              })
            }
          }
        }
      }
      this.tableSetData(e, i, dataList, pageNum)
    },
    // 获取工坊明细的字段
    getWorkShopKey (str, tdConfig) {
      let index1 = str.indexOf('{')
      let index2 = str.indexOf('}')
      str = str.substring(index1 + 1, index2)
      let strArr = str.split('.') || []
      const userKey = ['userId', 'realname', 'username', 'phone', 'elecsign', 'avatar', 'idcard', 'orgname', 'schoolname']
      if (tdConfig.type === 'relation-user' || userKey.includes(tdConfig.value)) {
        strArr = [strArr[0], strArr[1]]
        str = strArr.join('.')
      }
      return { strArr, str }
    },
    // 其他表的赋值
    tableSetData (e, sheetIndex, dataList, pageNum) {
      const celldata = cloneDeep(e)
      if (dataList && dataList.length > 0) {
        for (let index = 0; index < pageNum; index++) {
          // 超出数据条数就直接推出
          if (index > dataList.length - 1) break;
          celldata.r = e.r + index
          if (e.v.appid) {
            let dataType = this.getDataType(e.v.appid)
            // 工坊要重新设置一下数据标识 拓展组块用得到
            if (dataType === 2) {
              this.setCellFormatValue({ celldata, sheetIndex, format: { shopKey: e.v.v }})
            }
          }

          if (e.v.type === 'checkbox') {
            let value = dataList[index]
            value = Array.isArray(value) ? value.join() : ''
            this.setCellFormatValue({ celldata, sheetIndex, format: { v: value }})
            //明细联系人，值是数组要转成字符串
          } else if (e.v.type === 'relation-user') {
            const row = celldata.r
            let val = dataList[index] || []
            if (val && typeof val === 'object' && !Array.isArray(val)) {
              const { strArr } = this.getWorkShopKey(e.v.v, e.v)
              if (strArr.length > 1) {
                // 大于1 说明是明细里面的联系人
                val = val[strArr[1]] || []
              }
            }
            this.handleUser(e, val, sheetIndex, row)
          } else if (e.v.type === 'image') {
            this.handleImage(dataList[index], celldata, sheetIndex)
          } else {
            let data = dataList[index]
            if (e.v.type === 'organization') {
              data = Array.isArray(data) ? data.map(item => { return getOrgShowName(item) }).join() : data
            } else if (e.v.type === 'roule') {
              data = Array.isArray(data) ? data.map(item => { return item.name }).join() : data
            }
            this.setCellFormatValue({ celldata, sheetIndex, format: { v: data }})
          }
        }
      } else {
        // 没有值了就设置为空
        this.setCellFormatValue({ celldata, sheetIndex, format: { v: '' } })
      }
    },
    // 判断数据源类型
    getDataType (appid) {
      // 当前模板的数据源
      let dataType = 1
      const dataSourceList = this.detailConfig.dataSource.formList
      for (let index = 0; index < dataSourceList.length; index++) {
        const item = dataSourceList[index];
        if (item.appid == appid) {
          dataType = item.datatype
          break;
        }
      }
      return dataType
    },
    // 获取其他表的appid
    getOtherAppid (e) {
      let appid = 0
      const name = e.v.Ftype === 'details' ? `${e.v.Ftitle}_${e.v.Ftype}` : `${e.v.title}_${e.v.type}`
      for (const key in this.formdata) {
        if (this.formdata[key] && this.formdata[key].constructor === Object && Object.keys(this.formdata[key]).indexOf(name) !== -1) {
          appid = key
        } else {
          const { strArr } = this.getWorkShopKey(e.v.v, e.v)
          if (strArr && strArr.length > 0) { // 工坊
            if (this.formdata[key]
              && this.formdata[key].constructor === Object
              && Object.keys(this.formdata[key]).indexOf(strArr[0]) !== -1) {
              appid = key
            }
          }
        }
      }
      return appid
    },
    // 表格富文本的处理
    handleRichText (val, r, c, sheetIndex, insertData) {
      const word = val.split('${')
        .map(e => {
          if (e.search('}') !== -1) {
            const breakWord = e.split('}')
            const [name, type, title] = breakWord[0].split('_')
            const data = insertData[name] || insertData[title] || insertData[name + '_' + type] || insertData[title + '_' + type]
            if (type === 'relation-user') {
              e = data[0].username || data[0].realname || data[0].name
            } else if(type === 'organization' || type === 'roule') {
              e = Array.isArray(data) ? data.map(item => { return (type === 'organization' ? getOrgShowName(item) : item.name) || '' }).join() : data
            } else {
              e = data || ''
            }
            e = !e && e !== 0 ? '' : e
            e += breakWord[1]
          }
          return e
        })
        .join('')
      this.setCellFormatValue({ celldata: {r, c}, sheetIndex, format: { v: word } })
    },
    // 联系人数据的处理
    handleUser(e, val = [], sheetIndex, rowIndex = -1) {
      const type = e.v.value
      rowIndex = rowIndex < 0 ? e.r : rowIndex
      const cell = cloneDeep(e)
      cell.r = rowIndex
      if (val.length > 0) {
        if ((type === 'avatar' || type === 'elecsign') && val[0][type]) { // 这两都是图片 多人的时候只取第一个
          let url = val[0][type]
          const user = window.localStorage.getItem('user')
          if (user) {
            const accesstoken = JSON.parse(user).accesstoken
            url += `?accesstoken=${accesstoken}`
          }
          this.handleImage(url, cell, sheetIndex)
        } else {
          const arr = val.map(item => { return item[type] })
          this.setCellFormatValue({ celldata: cell, sheetIndex: sheetIndex, format: { v: arr.join() }})
        }
      } else {
        this.setCellFormatValue({ celldata: cell, sheetIndex: sheetIndex, format: { v: '' }})
      }
		},
    // 图片控件数据的处理
    async handleImage (val, e, i) {
      const { r, c } = e
      if (val === undefined || (Array.isArray(val) && val.length < 1)) {
        this.setCellFormatValue({ celldata: e, sheetIndex: i, format: { v: '' }})
        return false
      }
      const { width, height} = this.getTdWH(c, r, i)
      let imgUrl
      if (Array.isArray(val) && val.length > 0) {
        imgUrl = this.$url + val[0].response
      } else {
        imgUrl = this.$url + val
      }
      imgUrl = imgUrl.replace('userfiles', 'confiles')
      if (this.isDownReport) {
        imgUrl = await urlToBinary(imgUrl)
      }

      const image = new Image()
      image.src = imgUrl
      image.width = width
      image.style.width = '100%'
      image.style.height = height - 5 + 'px'
      this.setCellFormatValue({ celldata: e, sheetIndex: i, format: { v: this.domToString(image) }})
    },
    // 获取单元格的宽高
    getTdWH (c, r, i) {
      const sheetConfig = this.detailConfig.sheetList[i]
      const visibledatacolumn = sheetConfig.visibledatacolumn
      const visibledatarow = sheetConfig.visibledatarow
      let width = 0, height = 0
      if (sheetConfig.config.merge && sheetConfig.config.merge[`${r}_${c}`]) {
        const rows = sheetConfig.config.merge[`${r}_${c}`].rs
        const cols = sheetConfig.config.merge[`${r}_${c}`].cs
        // 因为配置这边的宽度没计算边框 所以一个单元格加1
        width = cols == 1 ? visibledatacolumn[c] - visibledatacolumn[c - 1] + c : visibledatacolumn[cols + c] - visibledatacolumn[c] + (cols + c + 1)
        height = rows == 1 ? visibledatarow[r] - visibledatarow[r - 1] : visibledatarow[rows + r] - visibledatarow[r]
      } else {
        width = c === 0 ? visibledatacolumn[c] + c + 1 : visibledatacolumn[c] - visibledatacolumn[c - 1] + c + 1
        height = r === 0 ? visibledatarow[r] : visibledatarow[r] - visibledatarow[r - 1]
      }
      return { width, height }
    },
    // 将 dom 元素转换为字符串
    domToString (node) {
      let tmpNode = document.createElement('div')
      tmpNode.appendChild(node)
      let str = tmpNode.innerHTML
      tmpNode = node = null; // 解除引用，以便于垃圾回收
      return str;
    },
    // 获取边界选区范围
    getRange () {
      let result
      const printBoxW = parseInt(this.printW * 3.78)
      const printBoxH = parseInt(this.printH * 3.78)
      // 表格长宽
      const visibledatacolumn = luckysheet.getSheet().visibledatacolumn
      const visibledatarow = luckysheet.getSheet().visibledatarow
      // 表格数据
      let col = visibledatacolumn.findIndex(e => { return e >= printBoxW })
      let row = visibledatarow.findIndex(e => { return e >= printBoxH })
      col = col !== -1 ? col : visibledatacolumn.length - 1
      row = row !== -1 ? row : visibledatarow.length - 1

      result = {
        col,
        row,
        h: visibledatarow[row],
        w: visibledatacolumn[col]
      }
      // 如果是连续打印
      if (this.showType === 'continuation') {
        row = visibledatarow.findIndex(e => { return e >= printBoxH }) - 1
        let maxRow
        const data = luckysheet.getSheet().data
        data.forEach((dataRow, rowIndex) => {
          dataRow.forEach(dataCol => {
            // 如果超出纸张范围且存在值
            if (dataCol && dataCol.v && rowIndex > row) {
              maxRow = rowIndex
            }
          })
        })
        result.row = maxRow || row
      }
      return {
        result
      }
    },
    // 计算图片宽高
    getImageWH (dom) {
      const domStyle = dom.style
      let res = {}
      res.width = Number(domStyle.width.split('mm')[0])
      res.height = Number(domStyle.height.split('mm')[0])
      return res
    },
    // 获取背景颜色
    getPageBackground (index) {
      // 0是纯色
      const pageConfig = this.detailConfig.sheetConfig[index]
      let Background
      if (pageConfig.backgroundValue === 0) {
        Background = pageConfig.backgroundColor
      } else {
        Background = "url('" + this.$imgurl + pageConfig.backgroundImage + "') no-repeat center"
      }
      return Background
    },
    // 获取预览内容
    getInfo (isGetHtml = false) {
      let ElPrint = document.querySelector('#preview-box')
      let sheetConfig = {}
      if (isGetHtml) {
        ElPrint = document.createElement('div')
      } else {
        // 重置一下页眉页脚的页码
        this.pageNum = 1
        // 清空盒子
        ElPrint.textContent = ''
        this.pageList = []
        this.startPage = 0
      }
      const allSheets = luckysheet.getAllSheets()
      allSheets.forEach(async (sheetItem, index) => {
        sheetConfig = this.detailConfig.sheetConfig[sheetItem.index]
        luckysheet.hideGridLines({ order: index })
        luckysheet.setSheetActive(index)
        const range = this.getRange().result
        let tableInfo = luckysheet.getRangeHtml({ range: { row: [0, range.row], column: [0, range.col] } }); // 生成表格结构
        const DIV = document.createElement('div')
        let styleStr = `
                        box-sizing: border-box;
                        width: ${sheetConfig.pageDirection !== 'landscape' ? sheetConfig.excelWidth : sheetConfig.excelHeight}mm;
                        height: ${sheetConfig.pageDirection !== 'landscape' ? sheetConfig.excelHeight : sheetConfig.excelWidth}mm;
                        overflow: hidden;
                        margin: 0 auto;
                        background: ${this.getPageBackground(sheetItem.index)};
                        background-size: ${sheetConfig.backgroundSize};
                      `
        // 设置内边距
        const padding = sheetConfig.pageDirection !== 'landscape' ?
          `${sheetConfig.pageTop}mm ${sheetConfig.pageRight}mm ${sheetConfig.pageBottom}mm ${sheetConfig.pageLeft}mm`
          : `${sheetConfig.pageLeft}mm ${sheetConfig.pageTop}mm ${sheetConfig.pageRight}mm ${sheetConfig.pageBottom}mm`
        styleStr += `padding: ${padding};`
        DIV.style.cssText = styleStr
        DIV.style.position = 'relative'
        DIV.innerHTML = tableInfo
        const table = DIV.querySelector('table')
        table.style.width = range.w + 'px'
        table.style.height = range.h + 'px'
        table.style.borderCollapse = 'collapse'
        const calcChain = Array.isArray(sheetItem.calcChain) ? sheetItem.calcChain : []
        // 行循环
        const trList = table.querySelectorAll('tr')
        for (let trIndex = 0; trIndex < trList.length; trIndex++) {
          const trEl = trList[trIndex];
          // 单元格循环
          const tdList = trEl.querySelectorAll('td')
          tdList.forEach((tdEl, tdIndex) => {
            // 公式字段
            const calcChainIndex = calcChain.findIndex(item => { return item.r === trIndex && item.c === tdIndex })
            if (calcChainIndex !== -1) {
              // 获取最开始的设置
              const sheetConfig = this.detailConfig.sheetList[index]
              const cell = sheetConfig.data[trIndex][tdIndex]
              if (cell.ct && cell.ct.fa === 'yyyy"年"M"月"d"日"' && tdEl.innerHTML) {
                const str = tdEl.innerHTML
                var reg =/(\d{4})-(\d{2})-(\d{2})/;
                var date = str.replace(reg,"$1年$2月$3日");
                tdEl.innerHTML = date
              }
            }
            // 去掉左边框和上边框 因为dom转成图片边框会重叠
            if (tdEl.getAttribute('data-c') != 0) {
              tdEl.style['border-left'] = 'none'
            }
            // 有 isNewBorder 这个参数才会去除下边框
            if (this.detailConfig.isNewBorder && (Number(tdEl.getAttribute('data-r')) + 1) != trList.length) {
              tdEl.style['border-bottom'] = 'none'
            }
          })
        }
        const domId = this.setWaterMark(DIV) // 设置水印
        if (domId) {
          DIV.appendChild(document.querySelector(domId).cloneNode(true))
        }
        // 拓展设置
        if (sheetConfig.expandList && sheetConfig.expandList.length > 0) {
          this.setExpand(table, DIV, sheetConfig)
        }
        // 如果是连续显示就分页
        if (sheetConfig.showType === 'continuation') {
          const divList = this.pageCut(table, DIV, sheetConfig)
          if (divList && divList.length >= 1) {
            divList.forEach(divItem => {
              ElPrint.appendChild(divItem)
            })
          }
        } else {
          ElPrint.appendChild(DIV)
        }
        if (this.detailConfig.isFlow && index == allSheets.length - 1) {
          const div_clone = DIV.cloneNode(true)
          div_clone.querySelector('table').style.height = ''
          div_clone.querySelector('table').innerHTML = this.$refs.flowTable.querySelector('tbody').innerHTML
          ElPrint.appendChild(div_clone)
        }
      })
      // 总页数
      this.sheetLength = ElPrint.children.length
      // 给个延迟不然获取不到图片
      setTimeout(() => {
        // 页眉页脚设置
        this.setPage(ElPrint.children)
        if (isGetHtml) {
          const ElBatchPrint = document.querySelector('#batch-print-box')
          this.setImg('', ElPrint)
          Array.from(ElPrint.children).forEach(child => {
            ElBatchPrint.appendChild(child.cloneNode(true));
          });
        } else {
          this.setImg('previewBox')
          // 报表应用的批量下载 不需要渲染图片了
          if (this.isDownReport) {
            this.isLoading = false
            if (this.isDowning) {
              this.getDownReport()
            }
          } else {
            this.isLoading = false
            this.getPageImageList().then(imgList => {
              this.$emit('imageHandler', imgList)
              // this.isLoading = false
              if (this.isAllFiles) {
                this.toAllFiles(this.tableData.fileName, this.tableData.fileType)
              } else {
                // 批量下载不要缩放
                setTimeout(() => {
                  this.zoom(0)
                }, 100)
              }
            })
          }
          this.$emit('reportInit')
        }
      }, 100)
    },

    // 获取翻页模式的图片
    async getPageImageList (startIndex = 0) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        const that = this
        const endIndex = startIndex ? startIndex + 2 : this.initPageNum
        const firstPages = this.isAllFiles || this.isMobile ?
          this.$refs.previewBox.children :
          Array.from(this.$refs.previewBox.children).slice(startIndex, endIndex)
        for (const item of firstPages) {
          // 使用html2canvas将Vue组件渲染为图片
          const img = await that.getPageImage(item)
          if (img) {
            this.pageList.push(img)
          }
        }
        this.isInitPages = false
        resolve(this.pageList)
      })
    },
    // 获取翻页的图片
    async getPageImage (dom) {
      const that = this
      let img
      const canvas = await html2canvas(dom, {
        scale: this.isMobile ? 2 : 1, // 处理模糊问题
        dpi: 300, // 处理模糊问题
        logging: false,
        useCORS: true, // 是否尝试使用CORS从服务器加载图像
        ignoreElements: e => {
          if (
            that.isPageSet ||  // 有设置页眉页脚就不过滤
            e.contains(dom) ||
            dom.contains(e) ||
            e.tagName === 'STYLE' ||
            e.tagName === 'LINK' ||
            e.getAttribute('data-html2canvas') != null // header里面的样式不能筛掉
          ) {
            return false;
          }
          return true;
        }
      })
      if (canvas) {
        img = canvas.toDataURL("image/png")
      }
      return img
    },
    // 设置水印
    setWaterMark (EL) {
      const watermark = this.detailConfig.watermark
      if (watermark) {
        let waterMarkText = ''
        let status = ''
        for (let key in watermark) {
          if (key == 'custom' && watermark[key].value) {
            waterMarkText += ` ${watermark[key].text} `
          } else if (watermark[key]) {
            switch (key) {
              case 'user':
                var user = localStorage.getItem('user')
                if (user) {
                  waterMarkText += JSON.parse(user).name
                }
                break;
              case 'time':
                waterMarkText += ` ${dayjs().format('YYYY-MM-DD HH:mm:ss')} `
                break;
              case 'status':
                status = this.formdata['状态_status']
                break;
            }
          }
        }
        // 有文字再去添加水印
        if (waterMarkText) warterMark.set(waterMarkText, EL)
        // 勾选了状态
        if (status) {
          let domId
          switch (status) {
            case '已通过':
              domId = '#result1'
              break;
            case '未通过':
              domId = '#result2'
              break;
            case '已撤回':
              domId = '#result3'
              break;
          }
          return domId
        }
      }
    },
    // 设置图片
    setImg (boxName, ElPrint) {
      const imagesList = luckysheet.getAllSheets().map(item => {
        return item.images
      })
      console.log('图片列表', imagesList)
      let printBox
      if (ElPrint) {
        printBox = ElPrint.children
      } else {
        printBox = this.$refs[boxName].children
      }
      imagesList.forEach((item, index) => {
        if (item) {
          // 设置边距加上盒子内边距
          const pdL = this.pageConfig.pageLeft * 3.78 + 1
          let pdT = this.pageConfig.pageTop * 3.78 + 1
          for (const key in item) {
            const img = document.createElement('img')
            const div = document.createElement('div')
            img.src = item[key].src
            img.style.border = `${item[key].border.width}px ${item[key].border.style} ${item[key].border.color}`
            img.height = item[key].default.height
            img.width = item[key].default.width
            div.style.zIndex = 99
            div.style.position = 'absolute'
            div.style.height = item[key].default.height + 'px'
            div.style.width = item[key].default.width + 'px'
            div.style.left = item[key].default.left + pdL + 'px'
            div.style.top = ((item[key].default.top + pdT) * .993) + 'px'
            div.appendChild(img)
            printBox[index].appendChild(div.cloneNode(true))
          }
        }
      })
    },
    // 页眉页脚设置
    setPage (el) {
      // 判断一下是否有设置页眉页脚
      if (this.detailConfig.pageHeaderSet === undefined || !this.isPageSet) return false
      for (let i = 0; i < el.length; i++) {
        if (this.$refs.pageHeaderRef[i]) {
          el[i].appendChild(this.$refs.pageHeaderRef[i].cloneNode(true))
        }
        if (this.$refs.pageFooterRef[i]) {
          el[i].appendChild(this.$refs.pageFooterRef[i].cloneNode(true))
        }
      }
    },
    // 设置拓展块
    setExpand (tableEL, div, sheetConfig) {
      const table = tableEL.querySelector('tbody')
      // lucksheet上的表格数据
      const sheetData = luckysheet.getSheet().data
      sheetConfig.expandList.forEach((item, index) => {
        // 根据数据源去拓展 没设置数据源就不往下拓展
        if (JSON.stringify(item.dataSource) === '{}') return false
        // 数据源的数据条数
        let dataList = {}
        let dataListLen = 0
        // datatype为0就是选择的本表的明细
        if (item.dataSource.datatype == 0) {
          const name = `${item.dataSource.title}_${item.dataSource.type}`
          dataList = this.formdata[name] || []
          dataListLen = dataList.length || 0
          if (dataListLen && dataList[dataList.length - 1] && Array.isArray(dataList[dataList.length - 1])) {
            dataListLen -= 1
          }
        } else {
          dataList = this.formdata[item.dataSource.appid] || {}
          dataListLen = Object.keys(dataList).length > 0 ? dataList[Object.keys(dataList)[0]].length : 0
        }
        console.log('拓展数据源', dataList, dataListLen)
        // 记录这个拓展组块的行高
        let expandRowLen = item.range.row[1] - item.range.row[0] + 1
        // 根据表的条数做判断（第一条已经显示所以从第二条开始）
        for (let dataIndex = 1; dataIndex < dataListLen; dataIndex++) {
          // 循环行
          for (let i = 1; i <= expandRowLen; i++) {
            // i 用于判断当前组块的第几行
            let trIndex = item.range.row[0] + i - 1
            const trClone = table.children[trIndex].cloneNode(true)
            trClone.setAttribute('data-eIndex', index)
            // 循环列
            for (let j = item.range.column[0]; j <= item.range.column[1]; j++) {
              /**
               * 单元格存在设置
               * 只有其他表的数据和明细才需要重新赋值
               * 本表的数据直接复制即可
               **/
              if (sheetData[trIndex][j]) {
                const tdConfig = JSON.parse(JSON.stringify(sheetData[trIndex][j]))
                // if (tdConfig.v === undefined || (tdConfig.v !== 0 && !tdConfig.v)) continue
                // 因为合并单元格后,单元格数量会减少,没办法根据原本下标填入数据,只能通过data*判断现有的下标
                let tdIndex = j
                for (let _tdIndex = 0; _tdIndex < trClone.children.length; _tdIndex++) {
                  const td = trClone.children[_tdIndex]
                  const c = Number(td.getAttribute('data-c') || 0)
                  if (c === j) {
                    tdIndex = _tdIndex
                  }
                }
                // 其他表一级的控件
                if (tdConfig.appid || tdConfig.Ftype === 'others') {
                  // 判断他表是不是工坊 存在shopKey就是工坊的数据
                  if (tdConfig.shopKey) {
                    const { strArr, str } = this.getWorkShopKey(tdConfig.shopKey, tdConfig)
                    const userKey = ['userId', 'realname', 'username', 'phone', 'elecsign', 'avatar', 'idcard', 'orgname', 'schoolname']
                    let value = dataList[str] ? dataList[str][dataIndex] : dataList[strArr[0]][dataIndex][strArr[1]]
                    if (value === undefined && tdConfig.type === 'relation-user') {
                      value =  dataList[strArr[0]][dataIndex]
                    }
                    if (tdConfig.type === 'relation-user' || userKey.includes(tdConfig.value)) {
                      trClone.children[tdIndex].innerHTML = typeof value === 'object' ? value.map(item => item[tdConfig.value]).join() : value
                    } else if (tdConfig.type === 'image') {
                      if (Array.isArray(value) && value.length > 0) {
                        let imgUrl = this.$url + value[0].response
                        imgUrl = imgUrl.replace('userfiles', 'confiles')
                        const imgString = tdConfig.v
                        value = imgString.replace(/(<img[^>]*src=["'])[^"']*(["'][^>]*>)/, `$1${imgUrl}$2`);
                      } else {
                        value = ''
                      }
                      trClone.children[tdIndex].innerHTML = value
                    } else {
                      if (strArr.length === 3 && strArr[strArr[2]] !== undefined) {
                        value = value[strArr[2]]
                      }
                      trClone.children[tdIndex].innerHTML = value
                    }
                  } else {
                    const cloneData = dataList[`${tdConfig.title}_${tdConfig.type}`] && dataList[`${tdConfig.title}_${tdConfig.type}`][dataIndex]
                    if (cloneData) {
                      trClone.children[tdIndex].innerHTML = this.dealValue(tdConfig.type, cloneData)
                    }
                  }
                } else if (tdConfig.Ftype === 'details') {
                  // 明细的第几条
                  const detailIndex = tdConfig.detailIndex
                  const detailName = `${tdConfig.Ftitle}_${tdConfig.Ftype}`
                  const name = `${tdConfig.title}_${tdConfig.type}`
                  if (item.dataSource.datatype == 0) {
                    this.setExpandData(dataList[dataIndex][name], tdConfig.type, trClone.children[tdIndex])
                  } else {
                    // 其他表的明细控件
                    if (dataList[detailName] && dataList[detailName][dataIndex] && dataList[detailName][dataIndex][detailIndex]) {
                      trClone.children[tdIndex].innerHTML = dataList[detailName][dataIndex][detailIndex][name]
                    }

                  }
                }
              }
            }
            // insertIndex 是元素要插入的位置
            const insertIndex = item.range.row[1] + (expandRowLen * (dataIndex - 1)) + i
            table.insertBefore(trClone, table.children[insertIndex])
          }
        }
      })
    },
    // 返回拓展组块的不同控件的数据
    setExpandData (data, type, td) {
      if (type == 'image') {
        if (data.length > 0) {
          const url = this.$url + data[0].response
          td.querySelector('img').setAttribute('src', url);
        }
      } else {
        td.innerHTML = data
      }
    },
    // 处理一下显示值
    dealValue (type, val) {
      let value = val
      if (type === 'relation-user') {
        value = val.map(item => { return item.realname }).join()
      } else if (type === 'image') {
        let imgUrl
        if (Array.isArray(val) && val.length > 0) {
          imgUrl = this.$url + val[0].response
        } else {
          imgUrl = this.$url + val
        }
        imgUrl = imgUrl.replace('userfiles', 'confiles')
        const image = new Image()
        image.src = imgUrl
        image.style.width = '100%'
        image.style.height = '100%'
        value = this.domToString(image)
      }
      return value
    },
    // 根据单页面长度进行切页
    pageCut (table, div, sheetConfig) {
      let tableList = this.calcTableheight(table, sheetConfig)
      tableList = this.clearEmptyTable(tableList)
      const divClone = div.cloneNode(true)

      if (tableList.length >= 1) {
        const divList = []
        tableList.forEach(item => {
          divClone.replaceChild(item, divClone.querySelector('table'));
          divList.push(divClone.cloneNode(true))
        })
        return divList
      }
    },
    // 计算表格内容是否超过当前页面的高度, 要是有超过直接分成两张table
    calcTableheight (tableEL, sheetConfig) {
      const tableELClone = tableEL.cloneNode(true) // 复制出来的表节点
      tableELClone.style.height = ''
      tableELClone.style.width = ''
      tableELClone.querySelector('tbody').innerHTML = ''
      // 表格的高度
      const tableHeight = (sheetConfig.excelHeight - sheetConfig.pageTop - sheetConfig.pageBottom) * 3.78
      // const tableHeight = Number(tableEL.style.height.replace('px', ''))

      const table = tableEL.querySelector('tbody')
      let sumHeight = 0 // 计算一页的高度
      const tableList = [] // 要返回的表格列表

      let titleTr = null
      // 计算一下高度超出的部分
      for (let index = 0; index < table.children.length; index++) {
        const tr = table.children[index]
        const _tr = table.children[index + 1] // 下一行
        const trHeight = Number(tr.querySelector('td').style.height.replace('px', ''))
        const _trHeight = _tr ? Number(_tr.querySelector('td').style.height.replace('px', '')) : 0 // 下一行的高度
        sumHeight += trHeight
        if (sumHeight + _trHeight > tableHeight) {
          // 最后一格要是有边框要给他加上去
          for (let trIndex = 0; trIndex < tr.children.length; trIndex++) {
            const td = tr.children[trIndex]
            if (td.style['border-top']) {
              td.style['border-bottom'] = td.style['border-top']
            }
          }
        }
        tableELClone.querySelector('tbody').appendChild(tr.cloneNode(true))
        if (sumHeight + _trHeight > tableHeight) {
          // 当前tr超出页面高度 要切页了
          tableList.push(tableELClone.cloneNode(true))
          // 超出之后重新计算
          sumHeight = 0
          tableELClone.querySelector('tbody').innerHTML = ''
          // 是否下页重复标题
          const expandIndex = tr.getAttribute('data-eIndex')
          if (titleTr === null && expandIndex !== null && sheetConfig.expandList && sheetConfig.expandList[expandIndex] && sheetConfig.expandList[expandIndex].repeatTitle) {
            const titleIndex = sheetConfig.expandList[expandIndex].range.row[0] - 1
            titleTr = table.children[titleIndex].cloneNode(true)
          }
        }
        // 循环结束的时候把剩下的行给他加进去
        if (index === table.children.length - 1) {
          tableList.push(tableELClone.cloneNode(true))
        }
      }
      // titleTr不为null就是下页要重复标题
      if (titleTr !== null) {
        // 拓展下页重复标题的
        const _tableList = []
        let tablePage = 1
        for (const tableItem of tableList) {
          if (tablePage !== 1 && tableItem.querySelector('tbody').innerText.trim()) {
            tableItem.querySelector('tbody').insertBefore(titleTr.cloneNode(true), tableItem.querySelector('tbody').children[0])
          }
          _tableList.push(tableItem)
          tablePage++
        }
        return _tableList
      } else {
        return tableList
      }


    },
    // 清除一下没内容的表
    clearEmptyTable (tableEL) {
      const table = []
      for (let index = 0; index < tableEL.length; index++) {
        let isEmpty = true
        const tbody = tableEL[index].querySelector('tbody')
        if (tbody.innerText.trim()) {
          isEmpty = false
        }
        // 不为空就添加
        if (!isEmpty) {
          table.push(tableEL[index])
        }
      }
      return table
    },
    // 顶部操作按钮功能
    // 导出pdf
    // 批量导出(表单内的报表)
    async toAllFiles (fileName = 'test', fileType = 'png') {
      if (fileType === 'pdf') {
        await this.toPdf(fileName)
      } else if (fileType === 'png') {
        await this.toPNG(fileName)
      } else {
        await this.toWord(fileName)
      }
    },
    async getDownReport (isDowning) {
      if (isDowning) {
        this.isDowning = true
        this.reportPage = []
        this.handleCurrentChange(0)
      } else {
        this.resetZoom()
        this.$nextTick( async () => {
          const ElLen = this.$refs.previewBox.children.length
          const ElPrint = this.$refs.previewBox
          for (let i = 0; i < ElLen; i++) {
            const item = this.$refs.previewBox.children[i]
            const table = item.querySelector('table')
            // const width = item.style.width.split('mm')[0]
            // const table_width = table.style.width.split('px')[0]
            // const height = item.style.height.split('mm')[0]
            // const table_height = table.style.height.split('px')[0]
            // 先撤回对宽度高度的修改
            // item.style.width = '1142px'
            item.style.height = '1615px'

            table.style.width = '100%'
            // table.style.height = '100%'
          }
          let url
          if (this.fileInfo.fileType === 'pdf') {
            let page =
                `<!DOCTYPE html>
                  <html lang="en">
                    <head>
                      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                    </head>
                    <body>
                      ${ElPrint.innerHTML}
                    </body>
                </html>
                `
            // 后台转换的时候用不了rbg
            page = page.replaceAll('rgb(0, 0, 0)', '#000')
            url = await this.uploadPage(page)
          } else if (this.fileInfo.fileType === 'png') {
            // 使用html2canvas将Vue组件渲染为图片
            const canvas = await html2canvas(ElPrint, {
              scale: 2, // 处理模糊问题
              dpi: 300, // 处理模糊问题
              useCORS: true, // 是否尝试使用CORS从服务器加载图像
            })
            var save_url = canvas.toDataURL("image/png");
            url = await this.upLoadFile(save_url)
          } else if (this.fileInfo.fileType === 'doc') {
            const page = this.getDocPage(ElPrint)
            const converted = htmlDocx.asBlob(page)
            const blob = new Blob([converted], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
            const formData = new FormData();
            formData.append('file', blob, `${this.fileInfo.fileName}.doc`);
            const config = {
              headers:{
                'Content-Type':'multipart/form-data',
              },
            };
            const { data } = await axios.post('/api/uploadhtml?accesstoken=' + this.token, formData, config)
            url = data
          }
          this.reportPage.push(url)
          if (this.currentPage < this.pageTotal - 1) {
            this.handleCurrentChange(this.currentPage + 1)
          } else {
            this.isDowning = false
            this.$emit('getReportPage', this.reportPage)
          }
        })
      }
    },
    // 将base64转换为二进制文件流
    base64toFile (imageURL, filename = 'file') {
      let arr = imageURL.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let baseStr = atob(arr[1])
      let n = baseStr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = baseStr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    async upLoadFile (url) {
      const result = this.base64toFile(url, this.fileInfo.fileName);
      let formData = new FormData() //参数的格式是formData格式的
      formData.append("file", result) //参数
      const config = {
        headers:{
          'Content-Type':'multipart/form-data',
        },
      };
      const { data } = await axios.post('/api/uploadhtml?accesstoken=' + this.token, formData, config)
      return data
    },
    async uploadPage (page) {
      const blob = new Blob([page],{type : 'text/html'});
      const file = new File([blob], `${this.fileInfo.fileName}.txt`);
      const formData = new FormData();
      formData.append("file", file);
      const url = this.$apiurl + '/api/uploadhtml?accesstoken=' + this.token
      const { data } = await axios.post(url, formData, { "Content-Type": "multipart/form-data" }).catch(err => { console.log(err) })
      return data
    },
    getDocPage (ElPrint) {
      const app = ElPrint
      const cloneApp = app.cloneNode(true)
      // 设置一下table 第一行td的宽度
      const table = cloneApp.querySelectorAll('table')
      // 页数循环
      table.forEach((tableEl, tableIndex) => {
        let columnWith
        if (this.detailConfig.sheetList[tableIndex]) {
          columnWith = this.detailConfig.sheetList[tableIndex].visibledatacolumn
        } else {
          const len = this.detailConfig.sheetList.length
          columnWith = this.detailConfig.sheetList[len - 1].visibledatacolumn
        }
        tableEl.style.width = '100%'
        tableEl.style.position = 'relative'
        const trList = tableEl.querySelectorAll('tr')
        // 行循环
        for (let trIndex = 0; trIndex < trList.length; trIndex++) {
          const trEl = trList[trIndex];
          // 单元格循环
          const tdList = trEl.querySelectorAll('td')
          tdList.forEach((tdEl, tdIndex) => {
            const w = tdIndex == 0 ? columnWith[0] : columnWith[tdIndex] - columnWith[tdIndex - 1]
            if (tdEl.querySelector('img')) {
              tdEl.querySelector('img').width = tdEl.querySelector('img').width / 1.62
            }
            tdEl.style.width = `${w}px`
          })
          // 添加一个空白td设置高度
          const _tdEL = document.createElement('td')
          _tdEL.style.width = '1px'
          _tdEL.style.height = tdList[0].style.height // 获取每行第一个td的高度
          trEl.appendChild(_tdEL.cloneNode(true))
        }
      })
      let page =
          `<!DOCTYPE html>
            <html lang="en">
              <head>
                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
              </head>
              <body>
                ${ElPrint.outerHTML}
              </body>
          </html>
          `
      return page
    },
    async toPdf (fileName) {
      this.resetZoom()
      this.isLoading = true
      // this.getPrint()
      this.$nextTick(async () => {
        // 获取要导出的Vue组件
        const ElLen = this.$refs.previewBox.children.length
        const fristImg = this.getImageWH(this.$refs.previewBox.children[0])
        let pdf
        if (fristImg.width > 210) {
          pdf = new jsPDF('l', 'mm', [fristImg.width, fristImg.height])
        } else {
          pdf = new jsPDF('p', 'mm', 'a4')
        }
        for (let i = 0; i < ElLen; i++) {
          const item = this.$refs.previewBox.children[i]
          // 使用html2canvas将Vue组件渲染为图片
          const canvas = await html2canvas(item, {
            scale: 3, // 处理模糊问题
            dpi: 300, // 处理模糊问题
            useCORS: true, // 是否尝试使用CORS从服务器加载图像
            ignoreElements: e => {
              if (
                e.contains(item) ||
                item.contains(e) ||
                e.tagName === 'STYLE' ||
                e.tagName === 'LINK' ||
                e.getAttribute('data-html2canvas') != null // header里面的样式不能筛掉
              ) {
                return false;
              }
              return true;
            }
          })
          // 创建新的jsPDF文档
          // 将渲染的图片添加到PDF文档中
          const imgWH = this.getImageWH(item)

          pdf.addImage(canvas.toDataURL('image/jpeg'), 'JPEG', 0, 0, imgWH.width, imgWH.height)
          if (i < ElLen - 1) {
            pdf.addPage()
          }
        }
        // 下载PDF文件
        pdf.save(`${fileName}.pdf`)
        this.isLoading = false
        console.log('下载结束~~');
        if (this.isAllFiles) this.$emit('allFileCallBack')
      })
    },
    // 导出图片
    async toPNG (fileName) {
      this.isLoading = true
      // if (!this.isCustom) {
      //   this.getPrint()
      // } else {
      //   document.querySelector('#printMe').innerHTML = document.querySelector('#all-payroll-table').outerHTML
      // }
      this.$refs.previewBox.style.position = 'absolute'
      this.$nextTick(async () => {
        const ElPrint = this.$refs.previewBox
        // 使用html2canvas将Vue组件渲染为图片
        const canvas = await html2canvas(ElPrint, {
          scale: 2, // 处理模糊问题
          dpi: 300, // 处理模糊问题
          useCORS: true, // 是否尝试使用CORS从服务器加载图像
        })
        var save_url = canvas.toDataURL("image/png");
        var aLink = document.createElement("a");
        document.body.appendChild(aLink);
        aLink.href = save_url;
        aLink.download = `${fileName}`;
        aLink.click();
        document.body.removeChild(aLink);
        this.isLoading = false
        this.$refs.previewBox.style.position = ''
        if (this.isAllFiles) this.$emit('allFileCallBack')
      })
      console.log('下载结束');
    },
    // 导出文档
    async toWord (fileName) {
      this.isLoading = true
      // if (!this.isCustom) {
      //   this.getPrint()
      // } else {
      //   document.querySelector('#printMe').innerHTML = document.querySelector('#all-payroll-table').outerHTML
      // }
      this.$nextTick(async () => {
        // this.setImg('printContent')
        const app = this.$refs.previewBox
        const cloneApp = app.cloneNode(true)
        const canvases = app.getElementsByTagName('canvas')
        const cloneCanvases = cloneApp.getElementsByTagName('canvas')
        const promises = Array.from(canvases).map((ca, index) => {
          return new Promise((res) => {
            const url = ca.toDataURL('image/png', 1)
            const img = new Image()
            img.onload = () => {
              URL.revokeObjectURL(url)
              res()
            }
            img.src = url
            img.style.width = '100px'
            // 生成img插入clone的dom的canvas之前
            cloneCanvases[index].parentNode.insertBefore(img, cloneCanvases[index])
          })
        })
        const cloneCanvas = cloneApp.getElementsByTagName('canvas')
        // 移除原来的canvas
        Array.from(cloneCanvas).forEach((ca) => ca.parentNode.removeChild(ca))
        // 设置一下table 第一行td的宽度
        const table = cloneApp.querySelectorAll('table')

        // 页数循环
        table.forEach((tableEl, tableIndex) => {
          let columnWith
          if (this.detailConfig.sheetList[tableIndex]) {
            columnWith = this.detailConfig.sheetList[tableIndex].visibledatacolumn
          } else {
            const len = this.detailConfig.sheetList.length
            columnWith = this.detailConfig.sheetList[len - 1].visibledatacolumn
          }
          tableEl.style.width = '100%'
          const trList = tableEl.querySelectorAll('tr')
          // 行循环
          for (let trIndex = 0; trIndex < trList.length; trIndex++) {
            const trEl = trList[trIndex];
            // // 如果是空行就直接删掉退出本次循环
            // if (trEl.innerText.trim().length === 0 && (trList[trIndex - 1] && trList[trIndex - 1].innerText && trList[trIndex - 1].innerText.trim().length === 0)) {
            //   tableEl.querySelector('tbody').removeChild(trEl)
            //   continue
            // }
            // 单元格循环
            const tdList = trEl.querySelectorAll('td')
            tdList.forEach((tdEl, tdIndex) => {
              const w = tdIndex == 0 ? columnWith[0] : columnWith[tdIndex] - columnWith[tdIndex - 1]
              if (tdEl.querySelector('img')) {
                tdEl.querySelector('img').width = tdEl.querySelector('img').width / 1.62
              }
              tdEl.style.width = `${w}px`
            })
            // 添加一个空白td设置高度
            const _tdEL = document.createElement('td')
            _tdEL.style.width = '1px'
            _tdEL.style.height = tdList[0].style.height // 获取每行第一个td的高度
            trEl.appendChild(_tdEL.cloneNode(true))
          }
        })
        Promise.all(promises).then(() => {
          let page =
            `<!DOCTYPE html>
							<html lang="en">
								<head>
									<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
								</head>
								<body>
									${cloneApp.innerHTML}
								</body>
						</html>
						`
          const converted = htmlDocx.asBlob(page)
          saveAs(converted, `${fileName}.docx`)
          this.isLoading = false
        })
      })
    },
  },
  async created () {
    console.log('页面创建之前')
    // 传参按钮进来的id跟传参
    if (this.$route.query) {
      this.getSpace()
      if (this.$route.query.reportId) this.reportId = this.$route.query.reportId
      if (this.$route.query.search || this.customDeskInfo.search) {
        // 传参的值必须是数组
        let search = (this.$route.query && this.$route.query.search) || this.customDeskInfo.search
        search = JSON.parse(search)
        for (let key in search) {
          this.search[key] = Array.isArray(search[key]) ? search[key] : [search[key]]
        }
      }
    }
    if ((this.$route.query && this.$route.query.paramsList) || this.customDeskInfo.paramsList) {
      this.paramsList = JSON.parse((this.$route.query && this.$route.query.paramsList) || this.customDeskInfo.paramsList)
    }
    // 非应用的报表 先获取配置和reportFormId
    if (!this.isApproval) {
      // 获取报表的配置
      await this.getReportConfig()
      // 工坊不需要获取reportFormId
      if (this.detailConfig.dataSource.datatype !== 2) {
        const { reportFormId, lookqrcode, lookqrcodetypes, oqrcore, qrcodetypes } = await DealPrintData.getReportFormId(this.detailConfig.dataSource.appid, this.spaceId,  this.upaceId)
        this.reportFormId = reportFormId
        this.appInfo = { ...this.appInfo, ...{ // 二维码的信息
            lookqrcode,
            lookqrcodetypes: lookqrcodetypes ? isJSON(lookqrcodetypes) : [],
            oqrcore,
            qrcodetypes: qrcodetypes ? isJSON(qrcodetypes) : []
          }
        }
      }
      this.excelInitial()
    } else {
      this.excelInitial()
    }
  }
}
</script>

<style lang="scss" scoped>
  @media print {
    #preview-box {
      transform: scale(1) !important;
      top: 0 !important;
    }
  }
  #luckysheet {
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 0;
    display: none;
    position: absolute;
    // opacity: 0;
    // top: 0;
    // position: fixed;
    // top: 0;
    // left: 0;
    // z-index: 999999999;
  }
  .report-view {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    &-title {
      height: 54px;
      background-color: #f5f5f5;
      padding: 0 24px;
      border-radius: 4px 4px 0px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title-mode {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
      :deep(.el-button) {
        padding: 8px 16px;
      }
    }
    &-main {
      width: 100%;
      height: calc(100% - 108px);
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
      #preview-box {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
      }
      #batch-print-box {
        display: none;
      }
    }
    &-bottom {
      width: 100%;
      height: 54px;
      position: relative;
      .bottom-handle {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 363px;
        height: 54px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        background-color: #000000;
        color: #ffffff;

        .bottom-handle-c {
          width: 150px;
          display: flex;
          justify-content: space-around;

          .bottom-handle-reduce,
          .bottom-handle-amplify {
            width: 16px;
            height: 16px;
            border: 1px solid #ffffff;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            i {
              font-size: 12px;
            }
          }
        }
        .bottom-handle-r {
          cursor: pointer;
          padding: 3px 5px;
          border-radius: 3px;
          border: 1px solid #fff;
        }
      }
      :deep(.el-pagination) {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        .btn-prev,
        .btn-next {
          background: none !important;
          color: #999;
        }
        .el-pager li {
          background-color: #000;
        }
        .el-pagination__total,
        .el-pagination__jump,
        .el-pager li {
          color: #ffffff;
        }
      }
    }
    .prve-btn, .next-btn {
      position: absolute;
      z-index: 1;
      top: 50%;
      transform: translateY(-50%);
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background-color: #000;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      i {
        font-size: 24px;
      }
    }
    .prve-btn {
      left: 56px;
    }
    .next-btn{
      right: 56px;
    }
  }
  .flipbook {
    height: 100%;
  }
  .zoom-50, .zoom-75 {
    :deep(.flipbook-container) {
      transition: transform 1s ease;
      transform-origin: center;
    }
  }
  .other-element {
    position: absolute;
    z-index: -10;
  }
  .page-header,
  .page-footer {
    width: 100%;
    position: absolute;
    left: 0;
    box-sizing: border-box;
  }
  .page-header {
    top: 0;
  }
  .page-footer {
    bottom: 0;
  }
  .mask-box {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,.3);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .mask-box-text {
      color: #FFFFFF;
      font-size: 16px;
      position: relative;
      top: -60px;
    }
    .icon-tianjia1 {
      color: #FFFFFF;
      font-size: 32px;
      position: absolute;
      right: -15px;
      top: -15px;
      transform: rotate(45deg);
      cursor: pointer;
    }
    .el-button {
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }
</style>
